export default __webpack_public_path__ + "static/blanket.light-1b6dc9172a1fe6d8149cf26b2c35390ac817da1b756e3b79cabee9819fd2adca.png";